import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { ReleaseCardComponent } from './card/release-card.component';
import { ReleaseCoverComponent } from './cover/release-cover.component';
import { ReleaseMediaLightboxComponent } from './lightbox/release-media-lightbox.component';
import { ReleaseNoteRichTextComponent } from './rich-text/release-note-rich-text.component';
import { ReleaseSplashHostComponent } from './splash-host/release-splash-host.component';

/**
 * The eager slice of the release "What's New" feature (RA-2695): what the app-wide splash needs, plus the
 * card the Library and the editor's Preview reuse. Kept minimal — no editor code in the main bundle.
 * Imported by `AppModule` and by the lazy `ReleaseNotesModule`.
 *
 * Deliberately does not `exports: [SharedModule]`: that rule is for routed feature modules (the routed
 * `ReleaseNotesModule` does re-export it), and from an unrouted library imported by `AppModule` it would
 * only leak `SharedModule` into the app shell.
 */
@NgModule({
  imports: [SharedModule],
  declarations: [
    ReleaseCardComponent,
    ReleaseCoverComponent,
    ReleaseMediaLightboxComponent,
    ReleaseNoteRichTextComponent,
    ReleaseSplashHostComponent
  ],
  exports: [
    ReleaseCardComponent,
    ReleaseCoverComponent,
    ReleaseNoteRichTextComponent,
    ReleaseSplashHostComponent
  ]
})
export class ReleaseNotesSharedModule {}
